import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { META_PIXEL_READY_EVENT, trackMetaPageView } from '../utils/metaPixel';

export default function MetaPageViewTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const track = () => trackMetaPageView(`${pathname}${search}`);
    window.addEventListener(META_PIXEL_READY_EVENT, track);
    track();
    return () => window.removeEventListener(META_PIXEL_READY_EVENT, track);
  }, [pathname, search]);

  return null;
}
